/**
 * bundles.js
 * Lógica Híbrida: Muestra mensaje de WhatsApp Y cambia el botón a "Sin Stock".
 */

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('isProduct');
    const bundleButton = form ? form.querySelector('button[onclick*="addToCartBundle"]') : null;

    if (bundleButton) {
        bundleButton.onclick = function(e) {
            e.preventDefault(); 
            addToCartBundle('isProduct');
            return false;
        };
        console.log('[BUNDLE.js] Validación: Mensaje WhatsApp + Botón Sin Stock.');
    }
});

async function addToCartBundle(formId) {
    const form = document.getElementById(formId);
    
    // Referencia al contenedor del mensaje de error
    const errorContainer = document.getElementById('bundle-error-msg');
    
    // Limpiamos mensajes previos al iniciar un nuevo intento
    if (errorContainer) {
        errorContainer.style.display = 'none';
        errorContainer.innerHTML = '';
    }

    // 1. Verificaciones básicas
    if (typeof findSelectedVariant !== 'function' || typeof product === 'undefined') {
        console.error('[BUNDLE ERROR] Dependencias faltantes.');
        return;
    }

    const selectedVariant = findSelectedVariant(form); 
    if (!selectedVariant) return;

    const addButton = form.querySelector('#getCart');
    const originalButtonText = addButton ? addButton.innerText : 'Agregar';

    if (!selectedVariant.available) {
        markButtonSoldOut(addButton);
        return;
    }

    if (addButton) {
        addButton.disabled = true;
        addButton.innerText = 'Verificando...';
    }

    // 2. Preparar datos
    const bundleItems = [];
    const metafields = selectedVariant.metafields;
    const NAMESPACE = 'custom';
    
    if (!metafields) {
        resetButton(addButton, originalButtonText);
        return;
    }

    for (let i = 1; i <= 6; i++) {
        const idKey = `${NAMESPACE}.product_bundle_${i}`;
        const qtyKey = `${NAMESPACE}.product_bundle_${i}_qty`;
        const invKey = `${NAMESPACE}.product_bundle_${i}_inv`; 

        const variantId = metafields[idKey]?.value;
        const rawQty = metafields[qtyKey]?.value;
        const stockData = metafields[invKey] || { value: 0, policy: 'deny' }; 

        let quantity = 0;
        if (rawQty !== null && rawQty !== undefined) {
            quantity = parseInt(String(rawQty).trim(), 10);
            if (isNaN(quantity)) quantity = 0;
        }

        if (variantId && quantity > 0) {
            bundleItems.push({
                id: variantId,
                quantity: quantity,
                max_stock: stockData.value,
                policy: stockData.policy,
                index: i
            });
        }
    }

    if (bundleItems.length === 0) {
        resetButton(addButton, originalButtonText);
        return;
    }

    // 3. VALIDACIÓN CRUZADA
    try {
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Error al obtener carrito');
        const cartData = await cartResponse.json();

        for (const item of bundleItems) {
            if (item.policy === 'continue') continue;

            const cartItem = cartData.items.find(line => line.variant_id === item.id);
            const currentInCart = cartItem ? cartItem.quantity : 0;
            const totalRequested = currentInCart + item.quantity;

            // 🛑 SI FALTA STOCK
            if (totalRequested > item.max_stock) {
                
                // A) MOSTRAMOS EL MENSAJE DE WHATSAPP
                const whatsappUrl = "https://api.whatsapp.com/send/?phone=5491166028528&text&type=phone_number&app_absent=0";
                
                const htmlMessage = `
                    Producto sin stock, haz click 
                    <a href="${whatsappUrl}" target="_blank" style="text-decoration: underline; font-weight: bold; color: inherit;">acá</a> 
                    para comunicarte con nosotros via Whatsapp.
                `;

                if (errorContainer) {
                    errorContainer.innerHTML = htmlMessage;
                    errorContainer.style.display = 'block';
                } else {
                    alert("Producto sin stock. Por favor contáctanos por WhatsApp.");
                }

                // B) CAMBIAMOS EL BOTÓN A "SIN STOCK"
                if (addButton) {
                    addButton.disabled = true;
                    addButton.innerText = 'Sin Stock';
                    
                    // UX: Esperamos 3 segundos y reseteamos el BOTÓN (el mensaje queda visible)
                    // Esto es necesario para que el usuario pueda corregir la cantidad y volver a clickear.
                    setTimeout(() => {
                        resetButton(addButton, originalButtonText);
                    }, 3000);
                }
                
                return; // Detenemos el proceso aquí
            }
        }

        // 4. Si todo está bien, enviamos a Shopify
        if (addButton) addButton.innerText = 'Agregando...';

        const formData = { items: bundleItems.map(i => ({ id: i.id, quantity: i.quantity })) };

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: formData,
            success: function(data) {
                if (typeof getAdd === 'function') getAdd(data);
                if (addButton) {
                    addButton.disabled = false;
                    addButton.innerText = '¡Agregado!';
                    setTimeout(() => { addButton.innerText = originalButtonText; }, 2000);
                }
            },
            error: function(jqXHR) {
                console.error('[BUNDLE AJAX ERROR]', jqXHR);
                if (typeof getError === 'function') getError(jqXHR);
                
                // Si falla la API de Shopify también mostramos error en botón
                if (addButton) {
                    addButton.innerText = 'Error';
                    setTimeout(() => { resetButton(addButton, originalButtonText); }, 3000);
                }
            }
        });

    } catch (error) {
        console.error('[BUNDLE CHECK ERROR]', error);
        resetButton(addButton, originalButtonText);
    }
}

function resetButton(btn, text) {
    if (btn) {
        const form = btn.closest('form');
        const variantUnavailable =
            btn.dataset.variantAvailable === 'false' ||
            (form && form.dataset.variantAvailable === 'false');

        if (variantUnavailable) {
            markButtonSoldOut(btn);
            return;
        }

        btn.disabled = btn.dataset.quantityAllowed === 'false';
        btn.innerText = text;
    }
}

function markButtonSoldOut(btn) {
    if (!btn) return;
    btn.disabled = true;
    btn.innerText = 'Agotado';
}